__turbopack_context__.v({
  "button-up-scroll": "_3BSn6G_button-up-scroll",
});
